module.exports = __webpack_public_path__ + "static/media/user-icon.1044482c.png";